import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import { connect } from "react-redux";
import FloatCart from "../../FloatCart";
import Icon from '../../../helpers/icon';

import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import ProgressiveImage from "react-progressive-image";
import Customization from "../../Items/Customization";
import '../../../helpers/style.css';
import { Helmet } from "react-helmet";
import { addProduct, removeProduct } from "../../../../services/cart/actions";

class ItemsView extends Component {
    static contextTypes = {
		router: () => null,
	};
    state = {
        itemGroup: [],
        itemGroupItems: [],
        update: true,
		top_categories: [],
    };
    forceStateUpdate = () => {
		setTimeout(() => {
			this.forceUpdate();
			if (this.state.update) {
				this.setState({ update: false });
			} else {
				this.setState({ update: true });
			}

			
		}, 100);
	};
    componentDidMount() {
		if(this.props.match.params.store_id){
			this.apiCalls(this.props.match.params.id,this.props.match.params.store_id);
		}else{
			this.apiCalls(this.props.match.params.id,null);

		}


    }

	

	
	apiCalls = (id,store_id) => {
		if(store_id){
			axios
			.post('https://pykin.in/public/api/single-store/getCategories', {
				'id' : store_id
			})
			.then((response) => {
				const top_categories = response.data.top_categories;
				if (top_categories.length) {
					this.setState({
						top_categories: top_categories
					});
				} else {
					this.setState({
						top_categories: [],
					});
				}
	
			});
		}
		

        axios
            .post('https://pykin.in/public/api/single-store/get-item-group-items', {
                id: id
            })
            .then((response) => {
                const item_group = response.data.item_group;
                this.setState({
                    item_group: item_group,
                    itemGroupItems: item_group.items
                });
            });
	}
    render() {
		localStorage.setItem("font-css", "* { font-family: 'Poppins', sans-serif; }")

		const { addProduct, removeProduct, cartProducts } = this.props;

        return (
            <React.Fragment >
                <Helmet>
					<style type="text/css">{localStorage.getItem("font-css")}</style>
				</Helmet>
                {this.state.item_group && (
                    <React.Fragment>
                        <div style={{position: 'relative'}}>
                            <div className={`d-flex ${this.state.top_categories.length > 0 ? 'p-3' : 'header-item-groups mb-4' }`} style={{"justifyContent":"space-between","backgroundColor":"white","borderRadius":"0px 0px 10px 10px","width":"100%","position":"fixed","top":"-4px","zIndex":"9"}}>
                            	<span onClick={this.context.router.history.goBack} style={{"backgroundColor":"#00000012","borderRadius":"100%","padding":"3px"}}><Icon icon="arrow-left"/></span>
                            	<span onClick={() => this.context.router.history.push("/")} style={{"backgroundColor":"#00000012","borderRadius":"100%","padding":"3px"}}><Icon icon="home"/></span>
                            </div>
							{this.state.top_categories.length > 0 && (
							<div className="scroll-items-parent " style={{"marginTop":"17%"}}>
  								{this.state.top_categories.map((category, index) => (
										<div onClick={() => this.apiCalls(category.id,this.props.match.params.store_id)} className="scroll-item category-scroll">
											{category.name}
										</div>
								  ))}
							</div>
							)}
                            <img src={'https://pykin.in' + this.state.item_group.top_image} alt="ItemGroup" style={{width: '100%'}}/>
                        </div>
                        <div className="d-flex" style={{ flexWrap: 'wrap',marginBottom: '10rem' }}>
                            {this.state.itemGroupItems.map((item, index) => (
                                <div className="w-50 child-item p-10" key={index}  > 
                             	<DelayLink to={`/single-store-single_item/${item.id}`}>
                                    <img src={'https://pykin.in'+ item.image} style={{width: '44vw', height: '44vw'}} alt={item.name}/>
                                </DelayLink>
                                <div style={{"fontWeight":"bold","fontSize":"15px"}}>
                                    {item.name} 
                                </div>
                                <div style={{"fontWeight":"bold","fontSize":"12px","color":"#8a8a8ac4"}}>{item.short_desc}</div>
                                <div style={{"fontWeight":"bold","fontSize":"15px"}}> ₹{item.price}</div>
                                <div className="add-item-switches" style={{"display":"flex","justifyContent":"flex-end","position":"absolute","right":"10px","bottom":"10px"}}>
                           {cartProducts.find((cp) => cp.id === item.id) !==
														undefined && (
														<React.Fragment>
															<div className="item-actions  mt-2">
																<div
																	className="btn-group btn-group-sm border "
																	role="group"
																	aria-label="btnGroupIcons1"
																	style={{borderRadius:'0.5rem'}}
																>
																	{item.is_active ? (
																		<React.Fragment>
																			{item.addon_categories.length ? (
																				<button
																					disabled
																					type="button"
																					className="btn btn-add-remove"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																				>
																					<span class="btn-dec">-</span>
																					<Ink duration="500" />
																				</button>
																			) : (
																				<button
																					type="button"
																					className="btn btn-add-remove"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																					onClick={() => {
																						item.quantity = 1;
																						removeProduct(item);
																						this.forceStateUpdate();
																					}}
																				>
																					<span class="btn-dec">-</span>	
																					<Ink duration="500" />
																				</button>
																			)}

                                                                            <span className="pl-2 pr-2" style={{"color":"rgb(153 32 28)","display":"flex","justifyContent":"center","alignItems":"center","padding":"0 10px","fontWeight":"500","fontSize":"1rem",border: "1px solid #eaecee"}}>
																				<React.Fragment>
																					{
																						cartProducts.find(
																							(cp) =>
																								cp.id ===
																								item.id
																						).quantity
																					}
																				</React.Fragment>
																			</span>

																			{item.addon_categories.length ? (
																				<Customization
																					product={item}
																					addProduct={addProduct}
																					forceUpdate={this.forceStateUpdate}
																				/>
																			) : (
																				<button
																					type="button"
																					className="btn btn-add-remove robo"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																					onClick={() => {
																						
																						addProduct(item);
																						this.forceStateUpdate();
																					}}
																				>
																					<span className="robo" style={{"fontSize":"1.4rem","lineHeight":"14px","color":"#282c3f","fontWeight":"500"}}>+</span>
																					<Ink duration="500" />
																				</button>
																			)}
																		</React.Fragment>
																	) : (
																		<div className="robo text-danger text-item-not-available">
																			{localStorage.getItem("cartItemNotAvailable")}
																		</div>
																	)}
																</div>
															</div>
														</React.Fragment>
													)}

													{cartProducts.find((cp) => cp.id === item.id) ===
														undefined && (
														<React.Fragment>
															<div className="item-actions mt-2">
																{item.is_active ? (
																	<React.Fragment>
																		{item.addon_categories.length ? (
																			<Customization
																				product={item}
																				addProduct={addProduct}
																				forceUpdate={this.forceStateUpdate}
																			/>
																		) : (
																			<button
																				type="button"
																				className="robo btn btn-success"
																				style={{"position":"relative","border":"0.7px solid #AEAEAE","color":"#99201c","width":"70px","backgroundColor":"rgb(255, 255, 255)","letterSpacing":"0.8px","borderRadius":"3px"}}
																				onClick={() => {
																					item.quantity = 1;
																					addProduct(item);
																					this.forceStateUpdate();
																				}}
																			>
																				ADD
																				<span style={{"position":"absolute","top":"0px","right":"4px"}}>+</span>
																				<Ink duration="500" />
																			</button>
																		)}
																	</React.Fragment>
																) : (
																	<div className="robo text-danger text-item-not-available">
																		{localStorage.getItem("cartItemNotAvailable")}
																	</div>
																)}
															</div>
														</React.Fragment>
													)}
                                    </div>
                                </div>
                                
                            ))}
                        </div>
                    </React.Fragment>
                )}

                <FloatCart />

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
});

export default connect(
	mapStateToProps,
	{
		addProduct,
		removeProduct,
	}
)(ItemsView);